import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import {getGeneralStorage, setGeneralStorage} from '../middleware/dataStorage';
import { useOutletContext } from "react-router-dom";

import WordList from '../components/WordList.js'

export default function WordSummary(props) {
	const navigate = useNavigate();
	const [logger] = useOutletContext();
	
	const [searchParams, setSearchParams] = useSearchParams();
	const [target, setTarget] = useState(getGeneralStorage('wordAnalysisTarget') ?? "dse-excellence");
	const [format, setFormat] = useState(getGeneralStorage('wordAnalysisFormat') ?? "qmeaning");
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(100);
	const [itemId, setItemId] = useState(null);
	
	//alphabet, id, update
	const [orderBy, setOrderBy] = useState('update');
		
	

	return (<div>
		<div style={{
			textAlign:"left",
			margin:"10px 10px 0 20px",
			fontWeight:"bold",
			fontSize:"2rem"
			}}>Word Analysis</div>
		<WordList target={target}
			format={format}
			page={page}
			limit={limit}
			itemId={itemId}
			orderBy={orderBy}
			setParamCall={(prop) => {
				console.log(prop);
				let myParam = {
					target : prop.target,
					format : prop.format, 
					page : prop.page,
					limit : prop.limit, 
					itemId : prop.itemId,
					orderBy : prop.orderBy,
				};
				setSearchParams(myParam);
			}}
			showItemSearch={true}
			/>
	</div>);
}

